import DiagnosisCard from "./DiagnosisCard";

export default DiagnosisCard;